<template>
  <div>
    <div class="flex items-baseline justify-between">
      <h2 class="intro-y text-lg font-medium mt-10">{{ $t("views.productos.text1") }}</h2>
      <button type="button" class="btn btn-primary w-24 h-10" @click="newProductItem">
        <span>{{ $t("views.new") }}</span>
      </button>
    </div>
    <div class="grid grid-cols-12 gap-6 mb-12">
      <div class="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
        <p class="mr-auto">{{ $t("views.supplements.text2") }}</p>
        <!-- seleccion  certification-->
        <div class="cursor w-full sm:w-56 mt-3 sm:mt-0 sm:ml-auto md:ml-0 mr-5">
          <div class="w-full relative text-gray-700 dark:text-gray-300">
            <TomSelect class="w-full cursor" v-model="certification">
              <option value="0">{{ $t("views.perfil_marca.text20") }}</option>
              <option v-for="(cert, key) in certificationsProduct" :key="key" :value="cert.id">{{ cert.name }}</option>
            </TomSelect>
          </div>
        </div>
        <!-- seleccion brand -->
        <div class="cursor w-full sm:w-56 mt-3 sm:mt-0 sm:ml-auto md:ml-0 mr-5">
          <div class="w-full relative text-gray-700 dark:text-gray-300">
            <TomSelect class="w-full cursor" v-model="brand">
              <option value="0">{{ $t("views.supplements.text46") }}</option>
              <option v-for="(brand, key) in brands" :key="key" :value="brand.id">{{ brand.name }}</option>
            </TomSelect>
          </div>
        </div>
        <div class="cursor w-full sm:w-56 mt-3 sm:mt-0 sm:ml-auto md:ml-0 mr-5">
          <!-- seleccion  estado -->
          <div class="w-full relative text-gray-700 dark:text-gray-300">
            <TomSelect class="w-full cursor" v-model="statusFilter">
              <option value="0">{{ $t("views.supplements.text96") }}</option>
              <option value="1">{{ $t("views.supplements.UNREVIEWED") }}</option>
              <option value="2">{{ $t("views.supplements.REVIEWED") }}</option>
            </TomSelect>
          </div>
        </div>
        <div class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
          <div class="w-56 relative text-gray-700 dark:text-gray-300">
            <input
              type="text"
              class="form-control w-56 box pr-10 placeholder-theme-13"
              :placeholder="$t('views.supplements.text4')"
              v-model="searchInput"
            />
            <SearchIcon class="w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0" />
          </div>
        </div>
      </div>
      <!-- BEGIN: Data List -->
      <div class="intro-y col-span-12 overflow-auto">
        <table class="table table-report -mt-2">
          <thead>
            <tr>
              <th class="whitespace-nowrap">
                <div class="grid supplements-grid">
                  <div>{{ $t("views.perfil_marca.text2") }}</div>
                  <div>{{ $t("views.productos.text8") }}</div>
                  <div>{{ $t("views.productos.text5") }}</div>
                  <!--   <div>{{ $t('views.supplements.text45') }}</div>
                  <div>{{ $t('views.supplements.text47') }}</div> -->
                </div>
              </th>
              <th class="text-center whitespace-nowrap">{{ $t("views.productos.text36") }}</th>
              <th class="text-center whitespace-nowrap">{{ $t("views.supplements.text8") }}</th>
            </tr>
          </thead>
          <tbody class="">
            <template v-for="(item, itemKey) in products" :key="itemKey">
              <tr class="intro-x">
                <td>
                  <div class="grid supplements-grid cursor-pointer" @click="item.show = !item.show">
                    <!-- nombre a marca -->
                    <div>{{ item.brand }}</div>
                    <!-- nombre del tipo de sustancia-->
                    <div v-if="!item.show">{{ item.substance }}</div>
                    <!-- articulos a la vista -->
                    <div v-if="!item.show" class="flex flex-wrap">
                      <ul class="mt-2 truncate" v-if="item.articles.length > 0">
                        <li v-for="(article, bKey) in item.articles" :key="bKey">
                          {{ article.langs[global_lang].nameTicket }}...
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="w-full intro-x mt-5" v-if="item.show">
                    <!-- nombre de la marca -->
                    <h2 v-if="item.brand !== ''" class="dark:text-white font-medium mt-3">
                      {{ $t("views.perfil_marca.text2") }}:
                    </h2>
                    <p v-if="item.brand !== ''" class="mt-2">{{ item.brand }}</p>

                    <!-- substancia -->
                    <h2 v-if="item.substance !== ''" class="dark:text-white font-medium mt-2">
                      {{ $t("views.productos.text3") }}:
                    </h2>
                    <p v-if="item.substance !== ''" class="mt-3">{{ item.substance }}</p>
                    <!-- Mostrar listado de productos -->
                    <div class="w-full intro-x mt-5" v-if="item.show">
                      <h2 v-if="item.articles.length > 0" class="dark:text-white font-medium mt-5">
                        {{ $t("views.productos.text5") }}:
                      </h2>
                      <ul v-if="item.articles.length > 0">
                        <li v-for="(article, bKey) in item.articles" :key="bKey" class="mt-2">
                          <div class="w-2 h-1 rounded-full bg-gray-400 inline-block mr-2"></div>
                          <h2 class="dark:text-white font-medium">{{ article.langs[global_lang].nameTicket }}</h2>
                          {{ $t("views.productos.text3") }} :
                          <template v-for="(substance, skey) in article.substances" :key="skey">
                            {{ substance }} ,
                          </template>
                          - {{ $t("views.productos.text13") }}: {{ article.supplementFacts.perServing }} -
                          {{ $t("views.productos.text12") }}: {{ article.supplementFacts.supplyDays }} -
                          {{ $t("views.supplements.text53") }}: {{ article.naturalSource }} -
                          {{ $t("views.supplements.text52") }}: {{ article.format }} -
                          {{ $t("views.productos.text17") }}:
                          <template v-for="(label, lkey) in article.labels" :key="lkey"> {{ label }} , </template> -
                          {{ $t("views.productos.text15") }}:
                          <template v-for="(certificacion, ckey) in article.certifications" :key="ckey">
                            {{ certificacion }} ,
                          </template>
                          - {{ $t("views.productos.text32") }}: {{ article.components.componentActive }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
                <td class="table-report__action w-56 relative p-5" style="width: 25px">
                  <div
                    class="alert show py-1 px-4 w-max h-max-content text-white"
                    :class="{ 'green-ok': item.status == 2, 'red-danger': item.status == 1 }"
                  >
                    {{ $t(`views.perfil_marca.${getNameStatus(item.status)}`) }}
                  </div>
                </td>
                <td class="table-report__action w-56 relative p-5" style="width: 25px">
                  <div class="flex justify-center items-center">
                    <a class="flex items-center mr-3" href="javascript:;" @click="editProductItem(item)">
                      <CheckSquareIcon class="w-4 h-4 mr-1" />
                      {{ $t("views.edit") }}
                    </a>
                  </div>
                </td>
              </tr>
            </template>
            <tr v-if="loading">
              <td colspan="4" class="p-4">
                {{ $t("views.loading") }}
                <LoadingIcon icon="three-dots" color="currentColor" class="ml-4 inline-block" />
              </td>
            </tr>
            <tr>
              <td colspan="4" class="p-4">
                {{ $t("views.no_data") }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- END: Data List -->
      <!-- BEGIN: Pagination -->
      <div
        class="intro-y col-span-12 flex flex-wrap sm:flex-row sm:flex-nowrap items-center"
        v-if="products.length > 0"
      >
        <ul class="pagination">
          <li>
            <a class="pagination__link" href="javascript:;" @click="goPage(1)">
              <ChevronsLeftIcon class="w-4 h-4" />
            </a>
          </li>
          <li>
            <a class="pagination__link" href="javascript:;" @click="goPage('prev')">
              <ChevronLeftIcon class="w-4 h-4" />
            </a>
          </li>
          <li>
            <a
              class="pagination__link"
              v-if="pagination.total_pages >= getNumberPgae('first')"
              v-bind:class="{ 'pagination__link--active': pagination.page == getNumberPgae('first') }"
              href="javascript:;"
              @click="goPage(getNumberPgae('first'))"
              >{{ getNumberPgae("first") }}</a
            >
          </li>
          <li>
            <a
              class="pagination__link"
              v-if="pagination.total_pages >= getNumberPgae('second')"
              v-bind:class="{ 'pagination__link--active': pagination.page == getNumberPgae('second') }"
              href="javascript:;"
              @click="goPage(getNumberPgae('second'))"
              >{{ getNumberPgae("second") }}</a
            >
          </li>
          <li v-if="getNumberPgae('second') != getNumberPgae('') && pagination.total_pages >= getNumberPgae('')">
            <a
              class="pagination__link"
              v-bind:class="{ 'pagination__link--active': pagination.page == getNumberPgae('') }"
              href="javascript:;"
              @click="goPage(getNumberPgae(''))"
              >{{ getNumberPgae("") }}</a
            >
          </li>
          <li>
            <a class="pagination__link" href="javascript:;" @click="goPage('next')">
              <ChevronRightIcon class="w-4 h-4" />
            </a>
          </li>
          <li>
            <a class="pagination__link" href="javascript:;" @click="goPage(pagination.total_pages)">
              <ChevronsRightIcon class="w-4 h-4" />
            </a>
          </li>
        </ul>
        <div class="ml-auto mr-5 text-gray-600">
          {{ $t("views.pagination.items", { total: products.length }) }}
        </div>
        <select
          class="w-20 form-select box mt-3 sm:mt-0"
          v-model="pagination.per_page"
          @change="
            () => {
              changePerPage();
            }
          "
        >
          <option>10</option>
          <option>25</option>
          <option>35</option>
          <option>50</option>
        </select>
      </div>
      <!-- END: Pagination -->
    </div>
  </div>
</template>
<style scoped>
.cursor {
  cursor: pointer !important;
}

.table td.p-0 {
  padding: 0px !important;
}

.bg-color-1 {
  background-color: #828181;
}

.btn-primary {
  background: #6c869a !important;
  border-color: #6c869a !important;
}
</style>
<style>
.tom-select .ts-dropdown .option.active {
  background: #6c869a !important;
}

.top-bar .breadcrumb > a:not(.breadcrumb--active) {
  color: #6c869a !important;
}

.detail-food {
  display: grid;
  grid-auto-columns: 1fr 1fr 1fr 1fr;
  grid-column-gap: 2em;
  grid-row-gap: initial;
  -ms-grid-columns: 1fr 1fr 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  -ms-grid-rows: auto;
  grid-template-rows: auto;
}

.pagination li,
.pagination a,
.pagination a:focus,
.pagination a:active {
  outline: none !important;
}

.supplements-grid {
  grid-template-columns: 150px 200px 150px 150px 150px;
  align-items: center;
  width: 100%;
}

@media screen and (min-width: 1450px) {
  .supplements-grid {
    grid-template-columns: 12vw auto 15vw 12vw 12vw;
  }
}
</style>

<script>
/* import SupplementService from "/src/services/supplements.service"
 */
import ProductsService from "../../../services/products.service";
import _ from "lodash";
import BrandsService from "../../../services/brands.service";

export default {
  setup() {},
  data() {
    return {
      products: [],
      searchInput: "",
      pagination: {
        page: 1,
        total_pages: 3,
        per_page: 50,
        total: 0,
      },
      bg: 1,
      loading: true,
      brands: [],
      brand: "",
      certificationsProduct: [],
      certification: 0,
      statusFilter: "",
      status: this.$global.getAspect(),
      global_lang: localStorage.lang ? localStorage.lang : navigator.language.split("-")[0],
    };
  },
  watch: {
    searchInput: _.debounce(function (newSearch, oldSearch) {
      this.pagination.page = 1;
      this.getAll();
    }, 500),
    certification: function () {
      this.pagination.page = 1;
      this.getAll();
    },
    statusFilter: function () {
      this.pagination.page = 1;
      this.getAll();
    },
    "$i18n.locale": function (l) {},
  },
  created() {
    window.vue = this;
    this.getAll();
    this.getAllBrands();
    this.getCertificationsProducts();
  },
  methods: {
    getNameStatus(codeStatus) {
      switch (Number(codeStatus)) {
        case 1:
          return "UNREVIEWED";
        default:
          return "REVIEWED";
      }
    },
    getAllProducts() {
      const products = localStorage.getItem("products");
      if (products) {
        try {
          return JSON.parse(products);
        } catch {
          return [];
        }
      } else {
        return [];
      }
    },
    getAll() {
      var params = {
        pagination: this.pagination,
      };
      if (this.searchInput != "") {
        params.search = this.searchInput.replaceAll(" ", "_");
      }
      if (this.statusFilter !== "") {
        params.status = this.statusFilter;
      }
      if (this.certification > 0) {
        params.certification = this.certification;
      }

      this.loading = true;
      try {
        let products = this.getAllProducts();
        if (params.search) {
          products = products.filter((s) => s.name.toLowerCase().includes(params.search.toLowerCase()));
        }

        if (params.certification) {
          products = products.filter((s) => s.certificationId == params.certification);
        }

        // Paginación simulada
        const start = (this.pagination.page - 1) * this.pagination.per_page;
        const end = start + this.pagination.per_page;
        const paginatedProducts = products.slice(start, end);

        this.products = paginatedProducts.map((s) => {
          s.show = false;
          if (!s.contact) {
            s.contact = {
              name: null,
              position: null,
              email: null,
              phone: null,
            };
          }
          return s;
        });

        this.pagination.total_pages = Math.ceil(products.length / this.pagination.per_page);
        this.pagination.total = products.length;

        this.loading = false;
      } catch (error) {
        console.error("Error las marcas:", error);
        this.loading = false;
      }
    },
    getCertificationsProducts() {
      var _this = this;
      ProductsService.getCertificationsProducts()
        .then((response) => {
          _this.certificationsProduct = response.data ? response.data : response;
          var sB = _this.certificationsProduct.filter((b) => {
            return _this.products.certificationsProduct.includes(b.name);
          });
          _this.products.certificationsProduct = sB.map((b) => {
            return b.certification.toString();
          });
        })
        .catch(function (e) {
          _this.loading = false;
        });
    },
    getAllBrands() {
      BrandsService.getAllBrand()
        .then((response) => {
          this.brands = response.data ? response.data : response;
        })
        .catch(function (e) {
          this.loading = false;
        });
    },
    /* getBrands() {
      var _this = this
      BrandsService.getAllBrand().then((response) => {
        _this.brands(response.data) ? response.data : response
        var sB = _this.brands.filter(b => {
          return _this.products.brands.includes(b.name)
        })
        _this.products.brands = sB.map(b => {
          return b.brand.toString()
        })
      }).catch(function (e) {
        _this.loading = false
      })
    }, */
    /*   getBrands() {
        var _this = this
        SupplementService.getBrands()
          .then((response) => {
            // Asignar la lista de marcas al arreglo `brands`
            _this.brands = response.data ? response.data : response

            // Actualizar el estado de `products` si es necesario
            _this.products = _this.products.map((product) => {
              product.brandName = _this.brands.find((b) => b.id === product.brand)?.name || ''
              return product
            })
          })
          .catch(function (e) {
            console.error('Error al obtener las marcas:', e)
            _this.loading = false
          })
      }, */
    editProductItem(ProductItem) {
      console.log("Guardando suplemento en localStorage:", ProductItem);
      localStorage.setItem("ProductItem", JSON.stringify(ProductItem));
      this.$router.push({ path: "/supplement-productos-edit" });
    },
    newProductItem(ProductItem) {
      localStorage.removeItem("ProductItem");
      this.$router.push({ path: "/supplement-productos-new" });
    },
    goPage: function (param) {
      if (param == "prev") {
        this.pagination.page = this.pagination.page > 1 ? this.pagination.page - 1 : 1;
      } else if (param == "next") {
        this.pagination.page =
          this.pagination.page < this.pagination.total_pages ? this.pagination.page + 1 : this.pagination.total_pages;
      } else {
        this.pagination.page = param;
      }
      this.getAll();
    },
    getNumberPgae(type) {
      if (type == "first") {
        return this.pagination.page < 3 ? 1 : this.pagination.page - 1;
      } else if (type == "second") {
        return this.pagination.page > 2 ? this.pagination.page : 2;
      } else {
        return this.pagination.page > 2
          ? this.pagination.page + 1 > this.pagination.total_pages
            ? this.pagination.total_pages
            : this.pagination.page + 1
          : 3;
      }
    },
    changePerPage() {
      this.pagination.page = 1;
      this.pagination.per_page = Number(this.pagination.per_page);
      this.getAllProducts();
    },
    getNameCertification(id) {
      const cb = this.certificationsProduct.find((cb) => cb.id == id);
      if (cb) {
        return cb.name;
      }
      return "";
    },
  },
};
</script>
